import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted } from "vue";
import { questionMarkTooltipProps } from "./questionMarkTooltip";


export default /*#__PURE__*/_defineComponent({
  __name: 'questionMarkTooltip',
  props: questionMarkTooltipProps,
  setup(__props) {

const props = __props



const isOpen = ref<boolean>(false);
const activatorRef = ref<HTMLElement>();

const toggle = (): void => {
    if (props.disabled) {
        return;
    }
    isOpen.value = !isOpen.value;
};

const handleDocumentClick = (event: MouseEvent): void => {
    if (activatorRef.value?.contains(event.target as Node)) {
        return;
    }
    isOpen.value = false;
};

onMounted(() => {
    document.addEventListener("click", handleDocumentClick);
});

onUnmounted(() => {
    document.removeEventListener("click", handleDocumentClick);
});

return { __sfc: true,props, isOpen, activatorRef, toggle, handleDocumentClick }
}

})